import { AlertTriangle } from 'lucide-react';
import type { SyncStatus } from '@/hooks/useSyncStatus';

interface LiveIndicatorProps {
  syncStatus: SyncStatus;
}

export function LiveIndicator({ syncStatus }: LiveIndicatorProps) {
  const isPartial = syncStatus.status === 'partial';
  const isFailed = syncStatus.status === 'failed';

  return (
    <div className="flex items-center gap-2">
      {isFailed ? (
        <AlertTriangle className="h-3.5 w-3.5 text-red-400" />
      ) : (
        <div className={`w-1.5 h-1.5 rounded-full ${
          isPartial ? 'bg-[var(--ed-amber)]' : 'bg-[var(--ed-green)]'
        } shadow-[0_0_8px_rgba(74,186,122,0.5)] animate-pulse`} />
      )}
      <span className={`text-[0.7rem] ${
        isFailed ? 'text-[var(--ed-red)]' : isPartial ? 'text-[var(--ed-amber)]' : 'text-[var(--ed-green)]'
      }`}>
        {isFailed ? 'Sync Failed' : 'Live'}
      </span>
      {syncStatus.hoursAgo !== null && (
        <span className="text-[0.65rem] text-muted-foreground/50">
          Synced {syncStatus.hoursAgo}h ago
          {isPartial && ` (${syncStatus.accountsSynced}/${syncStatus.accountsTotal})`}
        </span>
      )}
    </div>
  );
}
